import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { BasketDozService } from "@app/components/distribution/doz/basket/basketDoz.service";
import { RegistryDozSpecificationDto } from "@app/ui_models/web-response";
import { SubDistributionDozController } from "@app/ui_controllers/subDistributionDozController";

@Component({
  selector: "app-distributionBasketDoz",
  templateUrl: "./basket.doz.component.html",
  styleUrls: ["/basket.doz.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class BasketDozComponent implements OnInit {

  constructor(private router: Router, private subDistributionDozController: SubDistributionDozController, public basket: BasketDozService) {
  }

  tabHeader: { label: string; key: string; }[] = tabHeaderDozBasket;
  loading = false;

  ngOnInit(): void {
    this.loadColumnOrder();
  }

  saveColumnOrder() {
    localStorage.setItem("basketDozColumnOrder", JSON.stringify(this.tabHeader));
  }

  loadColumnOrder() {
    const savedOrder = localStorage.getItem("basketDozColumnOrder");
    if (savedOrder) {
      this.tabHeader = JSON.parse(savedOrder);
    }
  }

  goToSubDistribution(): void {
    const beneficiary = this.basket.allItems()[0].beneficiaries?.find(beneficiary => beneficiary.organizationId = this.basket.selectedBaseId);
    if (beneficiary && beneficiary.id) {
      this.loading = true;
      this.subDistributionDozController.createSubDistribution([...this.basket.beneficiaryIds]).subscribe(data => {
        this.basket.clear();
        this.loading = false;
        this.router.navigate(["/sub/distribution/doz/view/" + beneficiary.distributionId + "&" + data.id]);
      });
    }
    // this.subDistributionDozController.createSubDistribution(this.basket.allItems()[0].)

  }

  getDistributedQuantityForBase(row: RegistryDozSpecificationDto): string {
    let retValue = "0";
    if (this.basket.selectedBaseId && row) {
      const beneficiar = row.beneficiaries?.find(beneficiar => beneficiar.organizationId === this.basket.selectedBaseId);
      if (beneficiar && beneficiar.quantityDoz) {
        retValue = beneficiar.quantityDoz + "";
      }
    }
    return retValue;
  }

}

export const tabHeaderDozBasket = [
  { key: "mnnId", label: "MHH ID" },
  { key: "mnnName", label: "MHH" },
  { key: "dosage", label: "Дозування" },
  { key: "tradeName", label: "Торгова назва" },
  { key: "series", label: "Серія/Каталожний номер" },
  { key: "distributedQuantity", label: "Розподілена кількість" },
  { key: "action", label: "" },
];
